import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const ElectricalGoodsShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Electrical Goods"
    sectionKey="Electrical Goods"
    backRoute="/sections/electrical-goods"
  />
);

export default ElectricalGoodsShipmentRequest;
